__webpack_require__.p = "https://cdn.n-tv.de/sport/0.86.1/_next/";